import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { DeleteButtonProps } from '../types';

/**
 * 删除按钮组件
 * 
 * 用于在画布上显示删除按钮，通过 Portal 渲染到画布容器中
 * 支持边线和节点的删除操作
 */
const DeleteButton: React.FC<DeleteButtonProps> = memo(({ position, onClick, canvasRef }) => {
  if (!canvasRef.current) return null;
  
  return createPortal(
    <button
      onClick={onClick}
      style={{
        position: 'absolute',
        left: position.left,
        top: position.top,
        transform: 'translate(-50%, -50%)',
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: '#ff4d4f',
        border: '2px solid #fff',
        color: '#fff',
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '16px',
        cursor: 'pointer',
        padding: 0,
        zIndex: 100,
        boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      ×
    </button>,
    canvasRef.current
  );
});

DeleteButton.displayName = 'DeleteButton';

export default DeleteButton;
